import { render, staticRenderFns } from "./CustomerRenewalOrder.vue?vue&type=template&id=5f8cc1a6&scoped=true&"
import script from "./CustomerRenewalOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerRenewalOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRenewalOrder.vue?vue&type=style&index=0&id=5f8cc1a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cc1a6",
  null
  
)

export default component.exports